
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import NewWfDetailPop from '@xt/www/components/newWfDetailPop/index.vue'
import type { Wenfang } from '@xt/client/utils/new-wf-detail-pop/types'
import BigBgImg from '../BigBgImg/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import type { WenfangItem } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    NewSwiper,
    LazyImg,
    NewWfDetailPop,
    BigBgImg
  }
})
export default class WenFang extends Vue {
  @Prop({ default: () => [] }) dataSource!: Array<WenfangItem>

  activeIndex: number = 0

  wfPopupShow: boolean = false
  wfPopupContent: Wenfang | null = null

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  get dataList() {
    return lodash.chunk(this.dataSource, 3)
  }

  showWFPopup(item: WenfangItem) {
    const { id, name, modal } = item
    const { qrcode, content, productList } = modal

    this.wfPopupContent = {
      id,
      toolName: name, // 弹窗标题 - 直接取文房装备名称
      description: content[0] || content[1], // 富文本描述
      appletUrl: qrcode // 二维码
    }

    if (productList) {
      this.wfPopupContent['productList'] = productList
    }

    this.wfPopupShow = true
  }

  closeWFPopup() {
    this.wfPopupShow = false
    this.wfPopupContent = null
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  handleChange(index: number) {
    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
